import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HierarchyTreeModule } from '@stg-js-ngx-core/hierarchy-tree';
import { HierarchySelectorComponent } from './hierarchy-selector.component'

@NgModule({
    declarations: [
        HierarchySelectorComponent,
    ],
    exports: [
        HierarchySelectorComponent
    ],
    imports: [
        CommonModule,
        HierarchyTreeModule
    ]
})
export class HierarchySelectorModule { }
